<template>
  <div class="action-menu">
    <div class="action-menu__btn">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 8V24" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 16H24" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <ul class="action-menu__list">
      <li class="action-menu__list-item">
        <a href="" class="action-menu__list-link">דיווח נוכחות</a>
      </li>
      <li class="action-menu__list-item">
        <a href="" class="action-menu__list-link">דיווח על אירוע חריג</a>
      </li>
      <li class="action-menu__list-item">
        <a href="" class="action-menu__list-link">משימה חדשה</a>
      </li>
      <li class="action-menu__list-item">
        <a href="" class="action-menu__list-link">דיווח על תקלה</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TheBottomMenu'
};
</script>
